import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/NavbarNew';
import Footer from './components/FooterNew';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/HomeNew';
import About from './pages/AboutNew';
import ProductsHub from './pages/ProductsHub';
import ProductPillarPage from './pages/ProductPillarPage';
import ProductRedirect from './components/ProductRedirect';
import Services from './pages/Services';
import Industries from './pages/Industries';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import BulkUpload from './pages/BulkUpload';
import Contact from './pages/Contact';
import Certifications from './pages/Certifications';
import Clients from './pages/ClientsNew';
import Gallery from './pages/Gallery';
import { AuthProvider, useAuth } from './context/AuthContext';
import './index.css';

// Protected Route Wrapper
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

// Layout for public pages (with Navbar/Footer)
const PublicLayout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Navbar />
    <main className="flex-grow pt-20">
      {children}
    </main>
    <Footer />
    <WhatsAppButton />
  </div>
);

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute allowedRoles={['admin', 'editor']}>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bulk-upload"
            element={
              <ProtectedRoute allowedRoles={['admin', 'editor']}>
                <BulkUpload />
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/industries" element={<PublicLayout><Industries /></PublicLayout>} />
          <Route path="/products" element={<PublicLayout><ProductsHub /></PublicLayout>} />
          <Route path="/products/:pillarSlug" element={<PublicLayout><ProductPillarPage /></PublicLayout>} />
          <Route path="/product/:id" element={<PublicLayout><ProductRedirect /></PublicLayout>} />
          <Route path="/categories" element={<Navigate to="/products" replace />} />
          <Route path="/categories/:slug" element={<Navigate to="/products" replace />} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/clients" element={<PublicLayout><Clients /></PublicLayout>} />
          <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
          <Route path="/certifications" element={<PublicLayout><Certifications /></PublicLayout>} />
          <Route path="/quote" element={<Navigate to="/contact" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
